import { Option } from "src/app/shared/interfaces/form-fields";

export enum ConsentPeriod {
  ONE_TIME = 1,
  WEEKLY = 2,
  MONTHLY = 3,
  BI_ANNUAL = 4,
  ANNUAL = 5,
  DAILY = 6
}

export enum ConsentDeliveryChannel {
  EMAIL = 1,
  SMS = 2,
  WHATSAPP = 3
}

export const CONSENT_PERIOD_OPTIONS: Option[] = [
  { label: 'One Time', value: ConsentPeriod.ONE_TIME },
  { label: 'Daily', value: ConsentPeriod.DAILY },
  { label: 'Weekly', value: ConsentPeriod.WEEKLY },
  { label: 'Monthly', value: ConsentPeriod.MONTHLY },
  { label: 'Bi-Annual', value: ConsentPeriod.BI_ANNUAL },
  { label: 'Annual', value: ConsentPeriod.ANNUAL },
];

export const CONSENT_DELIVERY_CHANNEL_OPTIONS: Option[] = [
  { label: 'Email', value: ConsentDeliveryChannel.EMAIL },
  { label: 'SMS', value: ConsentDeliveryChannel.SMS },
  { label: 'WhatsApp', value: ConsentDeliveryChannel.WHATSAPP }
];

export interface ConsentResponseModel<T> {
  data?: T;
  description?: string;
  status?: boolean;
  code?: number;
}

export interface IAddConsentType {
  name: string;
  description: string;
  isActive: boolean;
  consentPeriod: ConsentPeriod;
  cosentDeliveryChanell: ConsentDeliveryChannel;
}

export interface IConsentType {
  id?: string;
  name?: string;
  description?: string;
  isActive?: boolean;
  consentPeriod?: ConsentPeriod;
  cosentDeliveryChanell?: ConsentDeliveryChannel;
  createdAt?: Date;
  lastUpdatedAt?: Date;
}

export interface ICreateConsent {
  serviceId: string;
  otpConfigurationId: string;
  identifier: string[];
  consentTypeId: string;
}

export interface IConsent {
  clientId: string;
  id: string;
  serviceId: string;
  otpRequestId: string;
  identifier: string;
  consentTypeId: string;
  requestId: string;
  isConsented: boolean;
  consentGivenAt: Date;
  consentStatus: number;
  consentExpiresAt: Date;
  createdDate: Date;
}

export interface IApproveConsent {
  id: string;
  consentApprovalCode: string;
}
